import React from "react";
import { PROOF_ITEMS, ProofItem } from "./constants";

// Tham khảo logic proof trúng thưởng từ src/pages/Home-Winaz-3/index.tsx —
// shuffle-bag chọn item không lặp lại sớm, hiện theo nhịp rồi ẩn (không phải
// luôn hiện): mỗi item hiện DISPLAY_DURATION, có animation exit rồi mới gỡ.
const DISPLAY_DURATION = 6000;
const EXIT_ANIMATION_DURATION = 500;
const NORMAL_DELAY_MIN = 5000;
const NORMAL_DELAY_MAX = 9000;
const INITIAL_DELAY = 2000;

export type ActiveProof = {
  uid: number;
  item: ProofItem;
  exiting: boolean;
};

export const useProofNoti = () => {
  const [active, setActive] = React.useState<ActiveProof | null>(null);
  const uidRef = React.useRef(0);
  const schedulerRef = React.useRef<number | null>(null);
  const shuffledRef = React.useRef<number[]>([]);
  const cursorRef = React.useRef(0);

  React.useEffect(() => {
    const rand = (min: number, max: number) => min + Math.random() * (max - min);

    const showNext = () => {
      if (cursorRef.current >= shuffledRef.current.length) {
        shuffledRef.current = [...Array(PROOF_ITEMS.length).keys()].sort(
          () => Math.random() - 0.5,
        );
        cursorRef.current = 0;
      }

      const itemIndex = shuffledRef.current[cursorRef.current++];
      const item = PROOF_ITEMS[itemIndex];
      const uid = ++uidRef.current;

      setActive({ uid, item, exiting: false });

      window.setTimeout(() => {
        setActive((prev) => (prev?.uid === uid ? { ...prev, exiting: true } : prev));
        window.setTimeout(() => {
          setActive((prev) => (prev?.uid === uid ? null : prev));
        }, EXIT_ANIMATION_DURATION);
      }, DISPLAY_DURATION);

      schedulerRef.current = window.setTimeout(
        showNext,
        rand(NORMAL_DELAY_MIN, NORMAL_DELAY_MAX),
      );
    };

    shuffledRef.current = [...Array(PROOF_ITEMS.length).keys()].sort(
      () => Math.random() - 0.5,
    );
    schedulerRef.current = window.setTimeout(showNext, INITIAL_DELAY);

    return () => {
      if (schedulerRef.current !== null) {
        window.clearTimeout(schedulerRef.current);
      }
    };
  }, []);

  return active;
};
